import React from "react";

import LogoLoader from "../LogoLoader";

// Loader de tela cheia (boot do app, troca de rota). Usa a animação da logo.
const BackdropLoading = () => <LogoLoader fullScreen />;

export default BackdropLoading;
